"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const jwt_1 = require("@nestjs/jwt");
const typeorm_1 = require("@nestjs/typeorm");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard");
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard");
const address_module_1 = require("../address/address.module");
const company_detail_entity_1 = require("../../../../service-lib/src/lib/entities/company-detail.entity");
const company_gst_detail_entity_1 = require("../../../../service-lib/src/lib/entities/company-gst-detail.entity");
const company_entity_1 = require("../../../../service-lib/src/lib/entities/company.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const policy_entity_1 = require("../../../../service-lib/src/lib/entities/policy.entity");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const look_up_repository_1 = require("../look-up/look-up.repository");
const comapny_service_1 = require("./comapny.service");
const company_controller_1 = require("./company.controller");
const company_repository_1 = require("./company.repository");
const opportunity_entity_1 = require("../../../../service-lib/src/lib/entities/opportunity.entity");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils/masters-validation");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
const notification_utils_1 = require("../../../../service-lib/src/lib/utils/notification.utils");
let CompanyModule = class CompanyModule {
};
exports.CompanyModule = CompanyModule;
exports.CompanyModule = CompanyModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                company_entity_1.Company,
                company_detail_entity_1.CompanyDetail,
                company_gst_detail_entity_1.StateGstDetail,
                policy_entity_1.Policy,
                look_up_entity_1.LookUp,
                opportunity_entity_1.Opportunity,
            ]),
            jwt_1.JwtModule,
            address_module_1.AddressModule,
        ],
        controllers: [company_controller_1.CompanyController],
        providers: [
            comapny_service_1.CompanyService,
            company_repository_1.CompanyRepository,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            entity_service_utils_1.EntityService,
            look_up_repository_1.LookUpRepository,
            lookup_validation_1.LookUpValidationService,
            masters_validation_1.MasterValidationService,
            scope_utils_1.ScopeService,
            notification_utils_1.NotificationUtils
        ],
        exports: [comapny_service_1.CompanyService, company_repository_1.CompanyRepository],
    })
], CompanyModule);
